import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=468e8f6c&scoped=true"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"
import style0 from "./Default.vue?vue&type=style&index=0&id=468e8f6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468e8f6c",
  null
  
)

export default component.exports